module.exports = __webpack_public_path__ + "img/02-02-img-02@2x.0cd7b5a1.png";